import { useQuery } from '@tanstack/react-query';
import {
  getSendHistory,
  getSendHistoryDetail,
  SendHistoryQuery,
} from 'api/sendHistory';
import { useAuth } from 'contexts/AuthContext';
import { queryKeys } from 'constants/queryKeys';

const manual = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
} as const;
export function useSendHistory(params: SendHistoryQuery) {
  const { user } = useAuth();
  return useQuery({
    queryKey: [queryKeys.SEND_HISTORY, user?.uid, 'list', params],
    queryFn: () => getSendHistory(params),
    enabled: Boolean(user?.uid),
    ...manual,
  });
}
export function useSendHistoryDetail(id: string | null) {
  const { user } = useAuth();
  return useQuery({
    queryKey: [queryKeys.SEND_HISTORY, user?.uid, 'detail', id],
    queryFn: () => getSendHistoryDetail(id!),
    enabled: Boolean(user?.uid && id),
    ...manual,
  });
}
